import _Sticky from './Sticky';
import { TdStickyProps } from './type';
import './style';

export const Sticky = _Sticky;
export type StickyProps = TdStickyProps;

export default Sticky;
